// extracted by mini-css-extract-plugin
export default {"DleRecordTypeSchema":"DleRecordTypeSchema_DleRecordTypeSchema__HUIuQ"};